export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/c7e28c55-5702-4a14-b096-1992227f97e4.png" 
                alt="AbiSoft Explorer Logo" 
                className="w-10 h-10 rounded-lg"
              />
              <span className="text-2xl font-bold">AbiSoft Explorer</span>
            </div>
            <p className="text-gray-400 mb-6">
              El futuro de la gestión de archivos. Potente, elegante y diseñado para la productividad.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>

          {/* Producto */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Producto</h3>
            <ul className="space-y-3 text-gray-400">
              <li><a href="#caracteristicas" className="hover:text-white transition-colors cursor-pointer">Características</a></li>
              <li><a href="#precios" className="hover:text-white transition-colors cursor-pointer">Precios</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Descargas</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Actualizaciones</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Documentación</a></li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Empresa</h3>
            <ul className="space-y-3 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Sobre nosotros</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Blog</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Carreras</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Prensa</a></li>
              <li><a href="#contacto" className="hover:text-white transition-colors cursor-pointer">Contacto</a></li>
            </ul>
          </div>

          {/* Soporte */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Soporte</h3>
            <ul className="space-y-3 text-gray-400">
              <li><a href="#faq" className="hover:text-white transition-colors cursor-pointer">FAQ</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Centro de ayuda</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Términos de servicio</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Política de privacidad</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Política de reembolso</a></li>
            </ul>
          </div>
        </div>

        {/* Barra inferior */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 AbiSoft Explorer. Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <div className="flex items-center space-x-2 text-sm text-gray-400">
              <i className="ri-shield-check-line text-green-400"></i>
              <span>SSL Seguro</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-400">
              <i className="ri-heart-fill text-red-400"></i>
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}